import React from 'react';
import { Users, Award, Target, Lightbulb } from 'lucide-react';

const About = () => {
  return (
    <section id="about-section" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-5xl font-bold text-gray-900 mb-4">
              About LiftGeo
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-[#6A7EC9] via-[#33C7A9] to-[#6A7EC9] mx-auto rounded-full"></div>
          </div>

          {/* Main Content */}
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100">
            <div className="flex items-start gap-4 mb-6">
              <div className="p-3 bg-gradient-to-br from-[#33C7A9] to-[#6A7EC9] rounded-xl shadow-lg">
                <Users className="h-8 w-8 text-white" />
              </div>
              <div className="flex-1">
                <p className="text-xl text-gray-700 leading-relaxed">
                  Our accomplished team of data and GIS professionals blends deep expertise in <span className="font-semibold text-[#6A7EC9]">business analytics</span>, <span className="font-semibold text-[#6A7EC9]">engineering</span>, <span className="font-semibold text-[#33C7A9]">commercial real estate</span>, and <span className="font-semibold text-[#33C7A9]">computer science</span> to deliver meaningful insights.
                </p>
              </div>
            </div>
            
            <div className="flex items-start gap-4 mt-8">
              <div className="p-3 bg-gradient-to-br from-[#6A7EC9] to-[#33C7A9] rounded-xl shadow-lg">
                <Lightbulb className="h-8 w-8 text-white" />
              </div>
              <div className="flex-1">
                <p className="text-xl text-gray-700 leading-relaxed">
                  We welcome the opportunity to discuss your questions and challenges.
                </p>
              </div>
            </div>

            {/* Stats/Features Grid */}
            <div className="grid md:grid-cols-3 gap-6 mt-12 pt-8 border-t border-gray-200">
              <div className="text-center">
                <div className="inline-flex p-4 bg-[#33C7A9]/10 rounded-full mb-3">
                  <Award className="h-8 w-8 text-[#33C7A9]" />
                </div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">Expert Team</h3>
                <p className="text-gray-600 text-sm">
                  Seasoned professionals in data science and GIS technology
                </p>
              </div>
              
              <div className="text-center">
                <div className="inline-flex p-4 bg-[#6A7EC9]/10 rounded-full mb-3">
                  <Target className="h-8 w-8 text-[#6A7EC9]" />
                </div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">Custom Solutions</h3>
                <p className="text-gray-600 text-sm">
                  Tailored analytics to meet your specific business needs
                </p>
              </div>
              
              <div className="text-center">
                <div className="inline-flex p-4 bg-[#33C7A9]/10 rounded-full mb-3">
                  <Lightbulb className="h-8 w-8 text-[#33C7A9]" />
                </div>
                <h3 className="font-bold text-gray-900 text-lg mb-2">Strategic Insights</h3>
                <p className="text-gray-600 text-sm">
                  Transform complex data into actionable intelligence
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
